import { Link } from "react-router-dom";
import { ArrowRight, MessageCircle } from "lucide-react";
import { waLink } from "@/data/site";
import LeadForm from "./LeadForm";

export const CtaBand = ({ title = "Raccontaci la tua attività. Al resto pensiamo noi.", wa = "preventivo" }) => (
  <section className="bg-p-mist py-14 md:py-20">
    <div className="wrap flex flex-col items-start justify-between gap-8 relative overflow-hidden rounded-3xl border border-violet-100 bg-p-preview p-8 sm:p-12 lg:flex-row lg:items-center">
      <div>
        <h2 className="max-w-xl text-2xl font-bold text-slate-900 sm:text-3xl">{title}</h2>
        <p className="mt-3 text-slate-700">Consulenza online gratuita, preventivo scritto, nessun impegno.</p>
      </div>
      <div className="flex flex-wrap gap-3">
        <Link to="/preventivo-gratuito" data-testid="cta-band-quote-btn" className="btn-primary">Richiedi un preventivo <ArrowRight className="h-4 w-4" /></Link>
        <a href={waLink(wa)} target="_blank" rel="noopener noreferrer" data-testid="cta-band-whatsapp-btn" className="btn-glass"><MessageCircle className="h-4 w-4" />WhatsApp</a>
      </div>
    </div>
  </section>
);

export const FinalCta = () => (
  <section id="contatto" className="bg-p-mist py-24 text-slate-700">
    <div className="wrap grid gap-14 lg:grid-cols-[1fr_1.1fr]">
      <div>
        <p className="eyebrow">Parliamone</p>
        <h2 className="mt-4 text-3xl font-bold leading-[1.1] text-slate-900 sm:text-4xl lg:text-5xl">Raccontaci la tua attività. Al resto pensiamo noi.</h2>
        <p className="mt-6 max-w-md text-slate-700">Rispondiamo entro un giorno lavorativo con una proposta chiara. Se preferisci, scrivici direttamente su WhatsApp.</p>
        <a href={waLink("preventivo")} target="_blank" rel="noopener noreferrer" data-testid="final-cta-whatsapp" className="btn-glass mt-8"><MessageCircle className="h-4 w-4" />Scrivici su WhatsApp</a>
      </div>
      <div className="bg-p-form rounded-3xl border border-emerald-100 p-6 shadow-[0_30px_60px_-40px_rgba(39,83,245,0.45)] sm:p-8 [&_.field]:border-slate-300">
        <LeadForm formType="contatto" />
      </div>
    </div>
  </section>
);
